"use strict";
/* tslint:disable */
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });
//==============================================================
// START Enums and Input Objects
//==============================================================
/**
 * Enum for fields that can be used for sorting
 */
var ColumnOrderField;
(function (ColumnOrderField) {
    ColumnOrderField["ID"] = "ID";
    ColumnOrderField["LUID"] = "LUID";
    ColumnOrderField["NAME"] = "NAME";
})(ColumnOrderField = exports.ColumnOrderField || (exports.ColumnOrderField = {}));
/**
 * Enum for fields that can be used for sorting
 */
var DashboardOrderField;
(function (DashboardOrderField) {
    DashboardOrderField["ID"] = "ID";
    DashboardOrderField["LUID"] = "LUID";
    DashboardOrderField["NAME"] = "NAME";
    DashboardOrderField["PATH"] = "PATH";
})(DashboardOrderField = exports.DashboardOrderField || (exports.DashboardOrderField = {}));
/**
 * Enum for fields that can be used for sorting
 */
var DatabaseOrderField;
(function (DatabaseOrderField) {
    DatabaseOrderField["CONNECTION_TYPE"] = "CONNECTION_TYPE";
    DatabaseOrderField["DOWNSTREAM_DATASOURCES_COUNT"] = "DOWNSTREAM_DATASOURCES_COUNT";
    DatabaseOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    DatabaseOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    DatabaseOrderField["ID"] = "ID";
    DatabaseOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    DatabaseOrderField["IS_EMBEDDED"] = "IS_EMBEDDED";
    DatabaseOrderField["LUID"] = "LUID";
    DatabaseOrderField["NAME"] = "NAME";
})(DatabaseOrderField = exports.DatabaseOrderField || (exports.DatabaseOrderField = {}));
/**
 * Enum for fields that can be used for sorting
 */
var DatabaseTableOrderField;
(function (DatabaseTableOrderField) {
    DatabaseTableOrderField["COLUMNS_COUNT"] = "COLUMNS_COUNT";
    DatabaseTableOrderField["CONNECTION_TYPE"] = "CONNECTION_TYPE";
    DatabaseTableOrderField["DOWNSTREAM_DASHBOARDS_COUNT"] = "DOWNSTREAM_DASHBOARDS_COUNT";
    DatabaseTableOrderField["DOWNSTREAM_DATASOURCES_COUNT"] = "DOWNSTREAM_DATASOURCES_COUNT";
    DatabaseTableOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    DatabaseTableOrderField["FULL_NAME"] = "FULL_NAME";
    DatabaseTableOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    DatabaseTableOrderField["ID"] = "ID";
    DatabaseTableOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    DatabaseTableOrderField["IS_EMBEDDED"] = "IS_EMBEDDED";
    DatabaseTableOrderField["LUID"] = "LUID";
    DatabaseTableOrderField["NAME"] = "NAME";
    DatabaseTableOrderField["SCHEMA"] = "SCHEMA";
})(DatabaseTableOrderField = exports.DatabaseTableOrderField || (exports.DatabaseTableOrderField = {}));
/**
 * Possible data types for a field.
 */
var FieldDataType;
(function (FieldDataType) {
    FieldDataType["BOOLEAN"] = "BOOLEAN";
    FieldDataType["DATE"] = "DATE";
    FieldDataType["DATETIME"] = "DATETIME";
    FieldDataType["INTEGER"] = "INTEGER";
    FieldDataType["REAL"] = "REAL";
    FieldDataType["SPATIAL"] = "SPATIAL";
    FieldDataType["STRING"] = "STRING";
    FieldDataType["TABLE"] = "TABLE";
    FieldDataType["TUPLE"] = "TUPLE";
    FieldDataType["UNKNOWN"] = "UNKNOWN";
})(FieldDataType = exports.FieldDataType || (exports.FieldDataType = {}));
/**
 * Enum for fields that can be used for sorting
 */
var FieldOrderField;
(function (FieldOrderField) {
    FieldOrderField["ID"] = "ID";
    FieldOrderField["IS_HIDDEN"] = "IS_HIDDEN";
    FieldOrderField["NAME"] = "NAME";
})(FieldOrderField = exports.FieldOrderField || (exports.FieldOrderField = {}));
/**
 * Possible roles of a field.
 */
var FieldRole;
(function (FieldRole) {
    FieldRole["DIMENSION"] = "DIMENSION";
    FieldRole["MEASURE"] = "MEASURE";
    FieldRole["UNKNOWN"] = "UNKNOWN";
})(FieldRole = exports.FieldRole || (exports.FieldRole = {}));
/**
 * Possible categories of a field role.
 */
var FieldRoleCategory;
(function (FieldRoleCategory) {
    FieldRoleCategory["NOMINAL"] = "NOMINAL";
    FieldRoleCategory["ORDINAL"] = "ORDINAL";
    FieldRoleCategory["QUANTITATIVE"] = "QUANTITATIVE";
    FieldRoleCategory["UNKNOWN"] = "UNKNOWN";
})(FieldRoleCategory = exports.FieldRoleCategory || (exports.FieldRoleCategory = {}));
/**
 * Enum for fields that can be used for sorting
 */
var FlowOrderField;
(function (FlowOrderField) {
    FlowOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    FlowOrderField["ID"] = "ID";
    FlowOrderField["LUID"] = "LUID";
    FlowOrderField["NAME"] = "NAME";
    FlowOrderField["PROJECT_NAME"] = "PROJECT_NAME";
    FlowOrderField["VIZPORTAL_URL_ID"] = "VIZPORTAL_URL_ID";
})(FlowOrderField = exports.FlowOrderField || (exports.FlowOrderField = {}));
/**
 * Enum for fields that can be used for sorting
 */
var FlowOutputFieldOrderField;
(function (FlowOutputFieldOrderField) {
    FlowOutputFieldOrderField["ID"] = "ID";
    FlowOutputFieldOrderField["NAME"] = "NAME";
})(FlowOutputFieldOrderField = exports.FlowOutputFieldOrderField || (exports.FlowOutputFieldOrderField = {}));
/**
 * Enum for fields that can be used for sorting
 */
var MetricOrderField;
(function (MetricOrderField) {
    MetricOrderField["ID"] = "ID";
    MetricOrderField["LUID"] = "LUID";
    MetricOrderField["NAME"] = "NAME";
    MetricOrderField["OWNER_COUNT"] = "OWNER_COUNT";
    MetricOrderField["PROJECT_NAME"] = "PROJECT_NAME";
    MetricOrderField["VIZPORTAL_URL_ID"] = "VIZPORTAL_URL_ID";
})(MetricOrderField = exports.MetricOrderField || (exports.MetricOrderField = {}));
/**
 * General object for sorting
 */
var OrderDirection;
(function (OrderDirection) {
    OrderDirection["ASC"] = "ASC";
    OrderDirection["DESC"] = "DESC";
})(OrderDirection = exports.OrderDirection || (exports.OrderDirection = {}));
/**
 * Enum for fields that can be used for sorting
 */
var PublishedDatasourceOrderField;
(function (PublishedDatasourceOrderField) {
    PublishedDatasourceOrderField["DOWNSTREAM_OWNERS_COUNT"] = "DOWNSTREAM_OWNERS_COUNT";
    PublishedDatasourceOrderField["DOWNSTREAM_SHEETS_COUNT"] = "DOWNSTREAM_SHEETS_COUNT";
    PublishedDatasourceOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    PublishedDatasourceOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    PublishedDatasourceOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    PublishedDatasourceOrderField["ID"] = "ID";
    PublishedDatasourceOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    PublishedDatasourceOrderField["LUID"] = "LUID";
    PublishedDatasourceOrderField["NAME"] = "NAME";
    PublishedDatasourceOrderField["OWNER_COUNT"] = "OWNER_COUNT";
    PublishedDatasourceOrderField["PROJECT_NAME"] = "PROJECT_NAME";
    PublishedDatasourceOrderField["VIZPORTAL_URL_ID"] = "VIZPORTAL_URL_ID";
})(PublishedDatasourceOrderField = exports.PublishedDatasourceOrderField || (exports.PublishedDatasourceOrderField = {}));
/**
 * Possible types of remote types
 *
 * Types correspond to OLEDB types here: https: // referencesource.microsoft.com/#system.data/System/Data/OleDb/OLEDB_Enum.cs,364"
 *
 * Types prefixed with 'WDC' correspond to Tableau's Web Data Connector types:
 * https:                                       // tableau.github.io/webdataconnector/docs/api_ref.html#webdataconnectorapi.datatypeenum
 */
var RemoteType;
(function (RemoteType) {
    RemoteType["ARRAY"] = "ARRAY";
    RemoteType["BOOL"] = "BOOL";
    RemoteType["BSTR"] = "BSTR";
    RemoteType["BYREF"] = "BYREF";
    RemoteType["BYTES"] = "BYTES";
    RemoteType["CY"] = "CY";
    RemoteType["DATE"] = "DATE";
    RemoteType["DBDATE"] = "DBDATE";
    RemoteType["DBTIME"] = "DBTIME";
    RemoteType["DBTIMESTAMP"] = "DBTIMESTAMP";
    RemoteType["DECIMAL"] = "DECIMAL";
    RemoteType["EMPTY"] = "EMPTY";
    RemoteType["ERROR"] = "ERROR";
    RemoteType["FILETIME"] = "FILETIME";
    RemoteType["GUID"] = "GUID";
    RemoteType["HCHAPTER"] = "HCHAPTER";
    RemoteType["I1"] = "I1";
    RemoteType["I2"] = "I2";
    RemoteType["I4"] = "I4";
    RemoteType["I8"] = "I8";
    RemoteType["IDISPATCH"] = "IDISPATCH";
    RemoteType["IUNKNOWN"] = "IUNKNOWN";
    RemoteType["NULL"] = "NULL";
    RemoteType["NUMERIC"] = "NUMERIC";
    RemoteType["PROPVARIANT"] = "PROPVARIANT";
    RemoteType["R4"] = "R4";
    RemoteType["R8"] = "R8";
    RemoteType["RESERVED"] = "RESERVED";
    RemoteType["STR"] = "STR";
    RemoteType["UDT"] = "UDT";
    RemoteType["UI1"] = "UI1";
    RemoteType["UI2"] = "UI2";
    RemoteType["UI4"] = "UI4";
    RemoteType["UI8"] = "UI8";
    RemoteType["VARIANT"] = "VARIANT";
    RemoteType["VARNUMERIC"] = "VARNUMERIC";
    RemoteType["VECTOR"] = "VECTOR";
    RemoteType["WDC_BOOL"] = "WDC_BOOL";
    RemoteType["WDC_DATE"] = "WDC_DATE";
    RemoteType["WDC_DATETIME"] = "WDC_DATETIME";
    RemoteType["WDC_FLOAT"] = "WDC_FLOAT";
    RemoteType["WDC_GEOMETRY"] = "WDC_GEOMETRY";
    RemoteType["WDC_INT"] = "WDC_INT";
    RemoteType["WDC_STRING"] = "WDC_STRING";
    RemoteType["WSTR"] = "WSTR";
})(RemoteType = exports.RemoteType || (exports.RemoteType = {}));
/**
 * Enum for fields that can be used for sorting
 */
var SheetOrderField;
(function (SheetOrderField) {
    SheetOrderField["DATASOURCE_FIELDS_COUNT"] = "DATASOURCE_FIELDS_COUNT";
    SheetOrderField["ID"] = "ID";
    SheetOrderField["LUID"] = "LUID";
    SheetOrderField["NAME"] = "NAME";
    SheetOrderField["PATH"] = "PATH";
    SheetOrderField["SHEET_FIELD_INSTANCES_COUNT"] = "SHEET_FIELD_INSTANCES_COUNT";
    SheetOrderField["WORKSHEET_FIELDS_COUNT"] = "WORKSHEET_FIELDS_COUNT";
})(SheetOrderField = exports.SheetOrderField || (exports.SheetOrderField = {}));
/**
 * Enum for fields that can be used for sorting
 */
var TableauUserOrderField;
(function (TableauUserOrderField) {
    TableauUserOrderField["DOMAIN"] = "DOMAIN";
    TableauUserOrderField["EMAIL"] = "EMAIL";
    TableauUserOrderField["ID"] = "ID";
    TableauUserOrderField["LUID"] = "LUID";
    TableauUserOrderField["NAME"] = "NAME";
    TableauUserOrderField["USERNAME"] = "USERNAME";
})(TableauUserOrderField = exports.TableauUserOrderField || (exports.TableauUserOrderField = {}));
/**
 * Enum for fields that can be used for sorting
 */
var WorkbookOrderField;
(function (WorkbookOrderField) {
    WorkbookOrderField["DASHBOARDS_COUNT"] = "DASHBOARDS_COUNT";
    WorkbookOrderField["EMBEDDED_DATASOURCES_COUNT"] = "EMBEDDED_DATASOURCES_COUNT";
    WorkbookOrderField["ID"] = "ID";
    WorkbookOrderField["LUID"] = "LUID";
    WorkbookOrderField["NAME"] = "NAME";
    WorkbookOrderField["OWNER_COUNT"] = "OWNER_COUNT";
    WorkbookOrderField["PROJECT_NAME"] = "PROJECT_NAME";
    WorkbookOrderField["SHEETS_COUNT"] = "SHEETS_COUNT";
    WorkbookOrderField["VIEWS_COUNT"] = "VIEWS_COUNT";
    WorkbookOrderField["VIZPORTAL_URL_ID"] = "VIZPORTAL_URL_ID";
})(WorkbookOrderField = exports.WorkbookOrderField || (exports.WorkbookOrderField = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
//# sourceMappingURL=globalTypes.js.map